export const transactionsTableConfig = {
  // Add translation keys to template when new columns are added here
  columns: [
    { prop: 'invoiceNumber', translationKey: 'invoiceNumber', flexGrow: 1 },
    { prop: 'productName', translationKey: 'name', flexGrow: 2 },
  ],
};
